import React from "react"
import { Toggle } from "material-ui"
import { ILeaveTrackingStateFilter, IDateRange, IDate } from "../../models"
import strings from "../../localization/strings"
import autobind from "class-autobind"
import DateRangeSelect from "../../components/common/DateRangeSelect"
interface IProps {
  stateFilter: ILeaveTrackingStateFilter
  dateFilter: IDateRange
  handleUpdateStateFilter(stateFilter: ILeaveTrackingStateFilter): void
  handleUpdateDateFilter(dateFilter: IDateRange): void
}
interface IState {
  startDate: IDate
  endDate: IDate
}

export default class LeaveTrackingFilter extends React.Component<IProps, IState> {
  constructor(props) {
    super(props)
    this.state = {
      startDate: this.props.dateFilter.StartDate,
      endDate: this.props.dateFilter.EndDate,
    }
    autobind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.dateFilter.StartDate !== nextProps.dateFilter.StartDate || this.props.dateFilter.EndDate !== nextProps.dateFilter.EndDate) {
      this.setState({
        startDate: nextProps.dateFilter.StartDate,
        endDate: nextProps.dateFilter.EndDate,
      })
    }
  }

  handleUpdateStateFilter(e, value) {
    const payload = Object.assign({}, this.props.stateFilter)
    payload[e.target.name] = value
    this.props.handleUpdateStateFilter(payload)
  }

  render() {
    return (
      <div style={{ padding: "0px 35px 0px 35px", display: "flex", marginTop: -10 }}>
        <div style={{ flex: 1, paddingTop: 35 }}>
          <Toggle
            data-intercom-target={"LeaveTracking-Filter-Toggle-Requested"}
            name="Requested"
            toggled={this.props.stateFilter.Requested}
            label={strings.Requested}
            onToggle={this.handleUpdateStateFilter}
            style={{ width: 110, display: "inline-block", marginRight: 15 }}
          />
          <Toggle
            data-intercom-target={"LeaveTracking-Filter-Toggle-Approved"}
            name="Approved"
            toggled={this.props.stateFilter.Approved}
            label={strings.Approved}
            onToggle={this.handleUpdateStateFilter}
            style={{ width: 110, display: "inline-block", marginRight: 15 }}
          />
          <Toggle
            data-intercom-target={"LeaveTracking-Filter-Toggle-Denied"}
            name="Denied"
            toggled={this.props.stateFilter.Denied}
            label={strings.Denied}
            onToggle={this.handleUpdateStateFilter}
            style={{ width: 110, display: "inline-block" }}
          />
        </div>
        <DateRangeSelect
          startDate={this.state.startDate}
          endDate={this.state.endDate}
          handleChange={(startDate, endDate, isValid) => isValid && this.setState({ startDate, endDate }, () =>
            this.props.handleUpdateDateFilter({ StartDate: this.state.startDate as string, EndDate: this.state.endDate as string })
          )}
        />
      </div>
    )
  }
}